<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Testimonials" />
            <TestimonialsComp />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import TestimonialsComp from '../Testimonials/TestimonialsComp'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'TestimonialsPage',
    components: {
        NavBar,
        PageTitle,
        TestimonialsComp,
        FooterComp,
    }
}
</script>